import type { PageRef } from '@wix/editor-platform-sdk-types'
import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import {
  DYNAMIC_PAGE_TYPES,
  DYNAMIC_PAGE_VARIANT,
  type DynamicPageType,
} from './dynamicPageTypes'
import { getPageTypeFromPattern } from './getTypeOfProbableDynamicPage'
import { getPatternDefForPage } from './router-config/routerConfig'
import { resolveIsDpVariant } from './dpVariants'

export const setDynamicPageTypeStateForAllPages = async ({
  editorSdkProxy,
}: {
  editorSdkProxy: EditorSDK
}): Promise<void> => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()

  const state: Record<string, PageRef[]> = {
    [DYNAMIC_PAGE_TYPES.ITEM_PAGE]: [],
    [DYNAMIC_PAGE_TYPES.INDEX_PAGE]: [],
    [DYNAMIC_PAGE_VARIANT]: [],
  }

  for (const router of routers) {
    for (const page of router.pages) {
      const isDpVariant = await resolveIsDpVariant({
        editorSdkProxy,
        pageRef: page.pageRef,
      })

      if (isDpVariant) {
        state[DYNAMIC_PAGE_VARIANT].push(page.pageRef)
      } else {
        const patternDef = getPatternDefForPage(
          router.config,
          router.pages,
          page.pageRef,
        )

        if (patternDef.pattern) {
          const type = getPageTypeFromPattern(patternDef.pattern)
          state[type].push(page.pageRef)
        }
      }
    }
  }

  await editorSdkProxy.pages.setState({ state })
}

export const setDynamicPageTypeStateForPage = async ({
  editorSdkProxy,
  pageRef,
  pageType,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
  pageType: DynamicPageType | typeof DYNAMIC_PAGE_VARIANT
}): Promise<void> => {
  editorSdkProxy.pages.setState({ state: { [pageType]: [pageRef] } })
}
